/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Internalization constants for EmailInput component
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

import ICommonTranslationEmailInput from '../../types/common/emailInput';

const initTranslationEmailInput: ICommonTranslationEmailInput = {
    hint: '',
    placeholder: '',
};

export default initTranslationEmailInput;
